module.exports = __webpack_public_path__ + "static/proces sprzedazy w CRM-d8c4208f9ddbbf2a4fcab6aa409bf07a.jpg";